exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-new-case[data-v-338de618]{width:90px;position:absolute;left:20px;top:0}.ivu-form .ivu-form-item-label[data-v-338de618]{font-size:15px}.ivu-input[data-v-338de618]{font-size:14px}.ivu-form .ivu-row[data-v-338de618]{top:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-338de618","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/addCase/AddNewCase.vue
// module id = zN6l
// module chunks = 2